<div class="notification-backdrop" (click)="onBackdropClick($event)">
  <div class="notification-panel">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-title">
        <app-icon name="Bell" [size]="20" />
        <h3>Сповіщення</h3>
        @if (unreadCount() > 0) {
          <span class="unread-badge">{{ unreadCount() }}</span>
        }
      </div>
      <div class="header-actions">
        @if (unreadCount() > 0) {
          <button class="mark-all-btn" (click)="markAllAsRead()">
            <app-icon name="CheckCircle" [size]="14" />
            Прочитати всі
          </button>
        }
        <button class="close-btn" (click)="onClose()">
          <app-icon name="X" [size]="18" />
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="panel-content">
      @if (isLoading()) {
        <div class="loading-state">
          <app-icon name="Loader" [size]="24" class="spin" />
          <span>Завантаження...</span>
        </div>
      } @else if (notifications().length === 0) {
        <div class="empty-state">
          <app-icon name="Bell" [size]="48" />
          <h4>Немає сповіщень</h4>
          <p>Коли з'являться нові сповіщення, вони відображатимуться тут</p>
        </div>
      } @else {
        <div class="notification-list">
          @for (notification of notifications(); track notification.id) {
            <div 
              class="notification-item" 
              [class.unread]="!notification.isRead"
              (click)="markAsRead(notification)"
            >
              <div class="notification-icon" [ngClass]="getNotificationIconClass(notification.type)">
                <app-icon [name]="getNotificationIcon(notification.type)" [size]="18" />
              </div>
              <div class="notification-content">
                <div class="notification-title">{{ notification.title }}</div>
                <div class="notification-message">{{ notification.message }}</div>
                <div class="notification-time">
                  <app-icon name="Clock" [size]="12" />
                  {{ getTimeAgo(notification.createdDate) }}
                </div>
              </div>
              @if (!notification.isRead) {
                <div class="unread-dot"></div>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="panel-footer">
      <button class="view-all-btn">
        Переглянути всі сповіщення
        <app-icon name="ArrowRight" [size]="14" />
      </button>
    </div>
  </div>
</div>
